import React, { Component } from 'react';
import { connect } from 'react-redux';

export class ContentItem extends Component {
 
  render() {
    const {
      position,
      itemText,
      itemSubText,
      cssColorClass,
      itemValue,
      isDarkMode,
      DOD = null,
    } = this.props;

    const isIncrease = DOD && DOD > 0;
    const DODText = DOD ? `${isIncrease ? '+': ''}${Math.round(DOD)}%`: '';
    const red = isDarkMode ? '#ff377f' : '#ff584d';
    const green = isDarkMode ? '#11E981' : '#11d06b';

    return (
      <div className={`${position + "-item"} content-item`}>
        <div className="item__wrap">
          <span className="item-text">{itemText}</span>
          <span className="item-sub-text">{itemSubText}</span>
        </div>
        <div className="value-wrapper">
          <span className={cssColorClass + " item-value"}>{itemValue}</span>
          {DOD && (
            <div className="dod-value">
              <span className={isIncrease ? 'green-triangle-svg' : 'red-triangle-svg'}
                style={{
                  width: 10,
                  height: 10,
                }}
              />
              <div style={{ color: isIncrease ? green : red}}>{DODText}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isDarkMode: state.common.isDarkMode,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentItem);



// WEBPACK FOOTER //
// ./src/features/scorecard/ContentItem.js